<template>
  <div class="container">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>口座番号</HeadingOne>

    <ErrorsAlert class="_mt-md-60 _mt-sm-50 _mb-sm-60" :errors="errors"></ErrorsAlert>

    <NoticeBox class="-error _mb-sm-40 _mb-md-60">
      <NoticeHeader>
        <h3 class="heading">以下の内容をご確認ください。</h3>
      </NoticeHeader>
      <NoticeBody>
        <ul>
          <li>
            一定回数以上入力の誤りがあったため、口座番号認証がロックされました。<br />
            翌日以降に再度ご入力ください。
          </li>
        </ul>
      </NoticeBody>
    </NoticeBox>

    <section>
      <BtngroupSingle class="_mb-md-120 _mb-sm-60">
        <BtnMain class="-normal -lg" router-name="mb001"> トップページ </BtnMain>
      </BtngroupSingle>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import {
  getUserDataLambdaInvoke,
} from "@/utils/LambdaHelper";
import { diffKeysGet } from "@/utils/ChangeIcon";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage } from "@/utils/Other";

import ErrorsAlert from "@/components/alert/ErrorsAlert";
import HeadingOne from "@/components/heading/HeadingOne";
import BtnMain from "@/components/button/BtnMain";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import NoticeBody from "@/components/box/NoticeBody";

export default {
  name: "Mb063",
  components: {
    BtnMain,
    BtngroupSingle,
    HeadingOne,
    ErrorsAlert,
    BreadcrumbGroup,
    NoticeHeader,
    NoticeBox,
    NoticeBody,
  },
  setup() {
    setMeta({
      title: "口座番号",
      description: "",
      keywords: "",
    });

    return {
      diffKeysGet,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "",
        },
        {
          text: "口座番号",
          active: true,
        },
      ],
      errors: {},
    };
  },
  mounted() {
    try {
      this.errors = {};
      getUserDataLambdaInvoke().then((res) => {
       this.errors = res.errors || {};
      });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.TableData {
  > .red {
    color: $danger;
    font-weight: bold;
  }
}
.btn-text {
  &:hover {
    text-decoration: underline;
    color: $orange !important;
  }
}
</style>
